import { HrMaxPrice } from './HrMaxPrice';
import { mapFinalCalculation, RawFinalCalculation } from './mapFinalCalculation';
import { mapProduct, RawProduct } from './mapProduct';
import { Reference } from './Reference';

export interface RawHrMaxPrice {
	readonly reference: {
		readonly packageSize: number | null;
		readonly referenceBasketVersion: string;
		readonly referencedProductType: string;
		readonly historicProductDataViewDate: string | null;
		readonly amountOfSubstanceInUnit: number | null;
	};
	readonly products: RawProduct[];
	readonly finalCalculation: RawFinalCalculation;
	readonly _links: { [key: string]: string };
}

export const mapHrMaxPrice = (hrMaxPrice: RawHrMaxPrice) =>
	new HrMaxPrice(
		new Reference(
			hrMaxPrice.reference.packageSize,
			hrMaxPrice.reference.referenceBasketVersion,
			hrMaxPrice.reference.referencedProductType,
			hrMaxPrice.reference.historicProductDataViewDate !== null
				? new Date(hrMaxPrice.reference.historicProductDataViewDate)
				: null,
			hrMaxPrice.reference.amountOfSubstanceInUnit
		),
		hrMaxPrice.products.map(mapProduct),
		mapFinalCalculation(hrMaxPrice.finalCalculation),
		hrMaxPrice._links
	);
